import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import '../main.css'

function Footer() {
    return (
        <footer className="footer" >
            <Container className='py-2 pt-4 custom-footer'>
                <Row className='text-muted text-center'>
                    <Col>
                        <p className="mb-0">
                            For inquiries, please <a href="/contact">contact us</a>.
                        </p>
                    </Col>
                </Row>
                <Row className="text-center">
                    <Col>
                        <p className="text-muted mb-0">
                            &copy; {new Date().getFullYear()} Barten Foundry Corporation. All rights reserved.
                        </p>
                    </Col>

                </Row>

            </Container>
        </footer>
    );
}

export default Footer;
